if (!customElements.get('newsletter-signup')) {
  customElements.define('newsletter-signup', class NewsletterSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.emailInput = this.querySelector('.newsletter__email');
      this.submitBtn = this.querySelector('.newsletter__submit');
      this.errorEl = this.querySelector('.newsletter__error');
      this.consentCheckbox = this.querySelector('.newsletter__consent-checkbox');
      this.successEl = this.querySelector('.newsletter__success');

      this.listId = this.dataset.listId;
      this.publicKey = this.dataset.publicKey;
      this.errorMessage = this.dataset.errorMessage || 'Something went wrong. Please try again.';
      this.originalLabel = this.submitBtn.textContent.trim();

      if (!this.listId || !this.publicKey) {
        console.warn('newsletter-signup: List ID or Public API Key not configured in section settings.');
        this.submitBtn.disabled = true;
        return;
      }

      this._onSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this._onSubmit);
    }

    disconnectedCallback() {
      if (this._onSubmit) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }

    async handleSubmit(e) {
      e.preventDefault();
      this.clearError();

      const email = this.emailInput.value.trim();

      if (!this.isValidEmail(email)) {
        this.showError('Please enter a valid email address.');
        return;
      }

      if (this.consentCheckbox && !this.consentCheckbox.checked) {
        this.showError('Please accept the terms to continue.');
        return;
      }

      this.setLoading(true);

      try {
        await this.subscribe(email);
        this.showSuccess();
        this.identify(email);
      } catch {
        this.setLoading(false);
        this.showError(this.errorMessage);
      }
    }

    identify(email) {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { '$email': email }]);
    }

    async subscribe(email, attempt = 0) {
      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${this.publicKey}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2023-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: { type: 'list', id: this.listId }
                  }
                }
              }
            })
          }
        );

        if (!res.ok) throw new Error(`Subscribe failed: ${res.status}`);
      } catch (err) {
        if (attempt === 0) {
          await new Promise(r => setTimeout(r, 600));
          return this.subscribe(email, 1);
        }
        throw err;
      }
    }

    showSuccess() {
      this.classList.add('is-subscribed');
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    clearError() {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }

    setLoading(on) {
      this.submitBtn.disabled = on;
      this.submitBtn.textContent = on ? 'Subscribing...' : this.originalLabel;
    }

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
  });
}
